import { render, staticRenderFns } from "./BankTransfer.vue?vue&type=template&id=55f4a7a1&scoped=true"
import script from "./BankTransfer.vue?vue&type=script&lang=ts"
export * from "./BankTransfer.vue?vue&type=script&lang=ts"
import style0 from "./BankTransfer.vue?vue&type=style&index=0&id=55f4a7a1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f4a7a1",
  null
  
)

export default component.exports